export const CLOUD_ZITI_EVENT_FIELDS = {
  identityName: 'identity_name.keyword',
  identityId: 'identity_id.keyword',
  edgeRouterName: 'edge_router_name',
  edgeRouterId: 'edge_router_id',
  serviceName: 'service_name',
  serviceId: 'service_id',
  hostName: 'host_name',
  resourceName: 'resource_name'
}
